import '../helpShift/js';
import $ from "jquery";
import 'slick-carousel';
import WOW from 'wow.js';
import './_download';
import './_youtube';
import './_tabs';
import './_show-password';
import './_input';
import popper from "popper.js";
import bootstrap from "bootstrap";
import {modalInfoHandlers} from './modal-info-handlers';
import {authHandlers} from './auth/auth-handlers';
import './_stage-button';
import {bindEventsToModal} from './_modal';
import {resizeLeftMenu} from './_resize-left-menu';
import {leftMenuAnchor} from './_left-menu-anchor';
import {buttonsAnimation} from './_buttons-animation';
import {downloadHandlers} from './download-handlers';
import {radioInputToggle} from './_radio-input';
import {videoPlayerHandlers} from './video-player-handlers';
import {sendAgainButton} from './_send-again-button';
import {mobileMenuHeight} from './_mobile-menu-height';
import {toggleSubMenu} from './_toggle-sub-menu';
import {customSelect} from './_custom-select';
import select2 from "select2";
import {helpShiftHandlers} from './helpShift/help-shift-handlers';

$(function () {
    sendAgainButton();
    modalInfoHandlers();
    authHandlers();
    downloadHandlers();
    videoPlayerHandlers();
    leftMenuAnchor();
    bindEventsToModal();
    resizeLeftMenu();
    buttonsAnimation();
    radioInputToggle();
    helpShiftHandlers();
    mobileMenuHeight();
    toggleSubMenu();
    customSelect();

    $(window).resize(function () {
        resizeLeftMenu();
        mobileMenuHeight();
    });

    navScroll();

    showToUp();

    termsCheckbox();

    window.subscribeForm = {
        showFormErrors: showFormErrors,
        submitAndReplace: submitAndReplace,
    };

    $('.custom-select').select2({
        minimumResultsForSearch: Infinity,
        width: 'resolve',
        theme: "custom",
        dropdownParent: $('#wrapper')
    });

    $('.tooltip').popover({
        container: 'body',
        placement: 'bottom',
        html: true,
        template: '<div class="popover" role="tooltip"><span class="popover-close" ></span><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    }).on('shown.bs.popover', function (eventShown) {
        var $popup = $('#' + $(eventShown.target).attr('aria-describedby'));

        $popup.find('.popover-close').click(function (e) {
            $popup.popover('hide');
        });
    });

    $('.lang-switcher__opener').on('click', function (event) {
        event.preventDefault();

        $(this).closest('.lang-switcher').addClass('lang-switcher--active')
    });

    $(document).click(function (event) {
        if ($(event.target).closest('.lang-switcher').length) {
            return;
        }

        $('.lang-switcher').removeClass('lang-switcher--active');

        event.stopPropagation();
    });

    $(".main-slider-list").slick({
        dots: true,
        arrows: false,
        centerMode: true,
        centerPadding: '20px',
        slidesToShow: 1,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    centerMode: false,
                    centerPadding: '0'
                }
            }]
    });

    $('.main-slider-list').on('beforeChange', function (e, slick, currentSlide, nextSlide) {
        const slideCount = slick.length - 1;
        const nextSlideIsFirst = currentSlide === slideCount;
        const nextSlideIsLast = nextSlide === slideCount;
        const $activeSlide = $('.slick-slide.slick-active');

        if (nextSlideIsFirst) {
            $activeSlide.next('.slick-slide').addClass('slick-clone-current');
        }

        if (nextSlideIsLast) {
            $activeSlide.prev('.slick-slide').addClass('slick-clone-current');
        }
    });

    $('.main-slider-list').on('afterChange', function (e, slick, currentSlide, nextSlide) {
        $('.slick-clone-current').removeClass('slick-clone-current');
    });

    $(".nav-opener").click(function (e) {
        e.preventDefault();

        $('body').toggleClass('nav-active');
    });

    $(window).scroll(function () {
        if ($('.nav-active').length) {
            $('body').removeClass('nav-active');
        }
    });

    $('.to-up').click(function (e) {
        $('body,html').animate({'scrollTop': 0}, 1000);

        e.preventDefault();
    });

    $('.jump-to').on('click', function (event) {
        var target = $(this).data('target');

        $.scrollTo(target);

        event.preventDefault();
    });

    var wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 100,
        mobile: false,
        live: true,
        callback: function (box) {
        },
        scrollContainer: null
    });

    wow.init();

    $('.left-menu__item > a').click(function () {
        window.location.hash = $(this).prop('hash');
    });
});

var subscribeFormErrors;

function showFormErrors(event, messages, errorAttributes) {
    var keys = [];
    var $place = $('.form-footer__error');

    if (subscribeFormErrors == undefined) {
        subscribeFormErrors = {};
    }

    delete subscribeFormErrors[messages.id];

    if (errorAttributes.length) {
        subscribeFormErrors[messages.id] = errorAttributes[0]
    }

    keys = Object.keys(subscribeFormErrors);

    if (keys.length == 0) {
        $place.text('');

        return;
    }

    if (keys.length == 1) {
        $place.text(subscribeFormErrors[keys[0]]);

        return;
    }

    if (keys.length > 1) {
        $place.text($place.data('error-text'));
    }
}

function submitAndReplace(form) {
    var data = $(form).serialize();
    var url = $(form).data('action');

    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        success: function (res) {
            $('.ajax-form-result').html(res);
        },
        error: function (err) {
            console.error('Ajax error ', err);
        }
    });

    return false;
}

function showToUp() {
    var status = 0;

    $(window).scroll(function () {
        if ($(window).scrollTop() > window.innerHeight * 0.8) {
            if (status === 0) {
                $('.to-up').addClass('to-up--active');

                status = 1;
            }
        } else {
            if (status === 1) {
                $('.to-up').removeClass('to-up--active');

                status = 0;
            }
        }
    })
}

$.scrollTo = function (target, offset, speed, container) {
    if (isNaN(target)) {
        if (!(target instanceof $)) {
            target = $(target);
        }

        target = parseInt(target.offset().top);
    }

    container = container || "html, body";

    if (!(container instanceof $)) {
        container = $(container);
    }

    speed = speed || 500;
    offset = offset || 0;

    container.animate({
        scrollTop: target + offset
    }, speed);
};

function navScroll() {
    var block = $('.section-slide');
    var navHeight = $('#header').height();

    $(window).scroll(function () {
        var _delta = -navHeight - 1;
        var _sections = [];
        var wS = $(window).scrollTop();

        block.each(function () {
            _sections.push($(this).offset().top + _delta);
        });

        $.each(_sections, function (i, val) {
            if (i > 0) {
                if (i == _sections.length - 1) {
                    if (wS >= val) {
                        $('.nav-list__item').find('.nav-list__link').removeClass('nav-list__link--active');
                        $('.nav-list__item').eq(i).find('.nav-list__link').addClass('nav-list__link--active');
                    }
                } else {
                    if ((wS >= val) && (wS < _sections[i + 1])) {
                        $('.nav-list__item').find('.nav-list__link').removeClass('nav-list__link--active');
                        $('.nav-list__item').eq(i).find('.nav-list__link').addClass('nav-list__link--active');
                    }
                }
            } else {
                if ((wS >= 0) && (wS < _sections[i + 1])) {
                    $('.nav-list__item').find('.nav-list__link').removeClass('nav-list__link--active');
                    $('.nav-list__item').eq(i).find('.nav-list__link').addClass('nav-list__link--active');
                }
            }
        });
    });

    $('.nav-list__link').click(function (e) {
        var index = $(this).parent().index();
        if (!$('body').hasClass('index-page')) {
            document.location = index && ('/#section' + index) || '/';

            return;
        }

        $('html, body').animate({scrollTop: block.eq(index).offset().top - navHeight}, 600);

        e.preventDefault();
    });

    if (window.location.hash.startsWith('#section')) {
        var index = parseInt(window.location.hash.replace('#section', ''));

        $('#header .nav .nav-list__link')[index].click();
    }
}

function termsCheckbox() {
    function hideModal() {
        $input.focus();
        $checkbox.focus();

        setTimeout(function () {
            $modal.modal('hide');
        }, 220);
    }

    const $checkbox = $('.checkbox-terms');
    const $modal = $('#user-agreement');
    const $input = $checkbox && $checkbox.prev('input');

    $('.js-btn-accept').on('click', function (event) {
        event.preventDefault();

        if (!$checkbox) {
            $modal.modal('hide');

            return;
        }

        $checkbox.prop('checked', true);

        hideModal();
    });

    $('.js-btn-reject').on('click', function (event) {
        event.preventDefault();

        if (!$checkbox) {
            $modal.modal('hide');

            return;
        }

        $checkbox.prop('checked', false);

        hideModal();
    });
}
